const initialState = {
  badges: [],
  badgeTypes: [],
  certificates: [],
  leaderboard: [],
  badgeCount: 0,
  certificateCount: 0,
  loading: false
};

export default function Badge(state = initialState, action) {

  switch (action.type) {

    case "SET_BADGES":
      return { ...state, badges: action.data };

    case "SET_BADGE_TYPES":
      return { ...state, badgeTypes: action.data };

    case "SET_CERTIFICATES":
      return { ...state, certificates: action.data };

    case "SET_BADGE_LEADERBOARD":
      return { ...state, leaderboard: action.data };

    case "SET_BADGE_COUNT":
      return { ...state, badgeCount: action.data };

    case "SET_CERTIFICATE_COUNT":
      return { ...state, certificateCount: action.data };

    case "SET_BADGE_LOADING":
      return { ...state, loading: action.data };

    case "ADD_BADGE":
      return { ...state, badges: [action.data, ...state.badges] };

    case "ADD_CERTIFICATE":
      return { ...state, certificates: [action.data, ...state.certificates] };

    case "REMOVE_BADGE":
      return { ...state, badges: state.badges.filter(b => b.id !== action.data) };

    case "REMOVE_CERTIFICATE":
      return { ...state, certificates: state.certificates.filter(c => c.id !== action.data) };

    default:
      return state;

  }

}
